import { styled } from '@mui/material/styles';

export const FieldGroup = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
